(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  window.BustmobCart = window.BustmobCart || (function () {
    function getDrawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function open() {
      var drawer = getDrawer();
      if (!drawer) return;

      drawer.hidden = false;
      document.body.style.overflow = 'hidden';

      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    }

    function close() {
      var drawer = getDrawer();
      if (!drawer) return;

      drawer.classList.remove('is-open');
      document.body.style.overflow = '';

      window.setTimeout(function () {
        drawer.hidden = true;
      }, 300);
    }

    function refresh(sections) {
      if (!sections) return;

      if (sections['cart-drawer']) {
        var drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshDrawer = drawerDoc.querySelector('[data-cart-drawer]');
        var liveDrawer = getDrawer();
        if (freshDrawer && liveDrawer) {
          liveDrawer.innerHTML = freshDrawer.innerHTML;
        }
      }

      if (sections['header']) {
        var headerDoc = new DOMParser().parseFromString(sections['header'], 'text/html');
        var freshCount = headerDoc.querySelector('[data-cart-count]');
        var liveCount = document.querySelector('[data-cart-count]');
        if (freshCount && liveCount) {
          liveCount.textContent = freshCount.textContent;
          liveCount.hidden = freshCount.hidden;
        }
      }
    }

    function change(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer,header' })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          refresh(data.sections);
          return data;
        });
    }

    function add(payload) {
      payload = payload || {};
      payload.sections = 'cart-drawer,header';

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }
          return response.json();
        })
        .then(function (data) {
          if (data.sections) refresh(data.sections);
          return data;
        });
    }

    return { open: open, close: close, refresh: refresh, change: change, add: add };
  })();

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]') || event.target.closest('[data-cart-drawer-backdrop]')) {
      window.BustmobCart.close();
      return;
    }

    var trigger = event.target.closest('[data-cart-drawer-trigger]');
    if (trigger) {
      event.preventDefault();
      window.BustmobCart.open();
      return;
    }

    var decrease = event.target.closest('[data-cart-quantity-decrease]');
    var increase = event.target.closest('[data-cart-quantity-increase]');
    var remove = event.target.closest('[data-cart-quantity-remove]');
    if (!decrease && !increase && !remove) return;

    var line = (decrease || increase || remove).getAttribute('data-line');

    if (remove) {
      window.BustmobCart.change(line, 0);
      return;
    }

    var input = document.querySelector('[data-cart-quantity-input][data-line="' + line + '"]');
    var current = input ? parseInt(input.value, 10) : 0;
    if (isNaN(current)) current = 0;

    var quantity = increase ? current + 1 : Math.max(0, current - 1);
    window.BustmobCart.change(line, quantity);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;

    window.BustmobCart.change(input.getAttribute('data-line'), quantity);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && !drawer.hidden) {
      window.BustmobCart.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var decrease = event.target.closest('[data-quantity-decrease]');
    var increase = event.target.closest('[data-quantity-increase]');
    if (!decrease && !increase) return;

    var stepper = (decrease || increase).closest('.product-quantity__stepper');
    var input = stepper && stepper.querySelector('[data-quantity-input]');
    if (!input) return;

    var min = parseInt(input.min, 10) || 0;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = min;

    value = increase ? value + 1 : Math.max(min, value - 1);

    input.value = value;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // header and the announcement banner above it are both position: fixed
  // (see stylesheet), stacked at the top of the viewport. The banner is
  // optional and variable-height (can be disabled, or wrap to 2 lines on
  // narrow viewports), so header's top offset can't be a fixed constant --
  // this measures the banner's real rendered height and exposes it as
  // --announcement-banner-height, which header's own `top` and every other
  // template's shared top-padding rule (assets/critical.css) both read from.
  function updateAnnouncementBannerHeight() {
    var banner = document.querySelector('.announcement-banner');
    var height = banner ? banner.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--announcement-banner-height', height + 'px');
  }

  updateAnnouncementBannerHeight();
  window.addEventListener('resize', updateAnnouncementBannerHeight);

  document.querySelectorAll('[data-header-menu-toggle]').forEach(function (toggle) {
    if (toggle.dataset.bound) return;
    toggle.dataset.bound = 'true';

    toggle.addEventListener('click', function () {
      var menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;

      var header = toggle.closest('header');
      var isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        isOpen ? toggle.getAttribute('data-label-close') : toggle.getAttribute('data-label-open')
      );

      if (isOpen) {
        if (header) menu.style.top = header.getBoundingClientRect().bottom + 'px';
        document.documentElement.classList.add('header-menu-open');
      } else {
        document.documentElement.classList.remove('header-menu-open');
      }
    });
  });

  window.addEventListener('resize', function () {
    var menu = document.querySelector('.header__menu.is-open');
    if (!menu) return;

    var header = menu.closest('header') || document.querySelector('header');
    if (header) menu.style.top = header.getBoundingClientRect().bottom + 'px';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-product-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-product-gallery]');
    var mainImage = gallery && gallery.querySelector('[data-product-gallery-main-image]');
    if (!mainImage) return;

    mainImage.src = thumb.getAttribute('data-full-src');
    mainImage.alt = thumb.getAttribute('data-alt') || '';

    gallery.querySelectorAll('[data-product-gallery-thumb]').forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
    });
  });

  // Grays out / strikes through any option button that would resolve to
  // an unavailable variant if selected, given the OTHER options currently
  // chosen (a null/not-yet-picked slot matches any value, same as the
  // matching logic below). Recomputed for every button on every change,
  // including ones in the group that was just clicked -- a value that's
  // currently selected can itself become unavailable once another
  // option's selection changes (see the CSS comment on
  // .product-option__button--unavailable for why that's still marked,
  // not silently left looking normal).
  function updateProductOptionAvailability(root, variants, selectedOptions) {
    root.querySelectorAll('[data-product-option-value]').forEach(function (optionButton) {
      var group = optionButton.closest('[data-product-option-group]');
      if (!group) return;

      var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
      var testOptions = selectedOptions.slice();
      testOptions[optionIndex] = optionButton.getAttribute('data-product-option-value');

      var matchingVariant = variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return testOptions[index] == null || value === testOptions[index];
        });
      });

      var isUnavailable = !matchingVariant || !matchingVariant.available;
      optionButton.classList.toggle('product-option__button--unavailable', isUnavailable);
    });
  }

  // Runs the same graying pass once on load, against whichever options
  // are pre-selected server-side (option.selected_value) -- otherwise a
  // product with an unavailable sibling combo (e.g. Size XL out of stock
  // in the default Color) would show every option as normal until the
  // shopper made a change, rather than reflecting real availability from
  // the first render.
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variantsEl = root.querySelector('[data-product-variants-json]');
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (error) {
      return;
    }

    var groups = root.querySelectorAll('[data-product-option-group]');
    var selected = Array.prototype.map.call(groups, function (g) {
      var active = g.querySelector('.is-selected');
      return active ? active.getAttribute('data-product-option-value') : null;
    });

    updateProductOptionAvailability(root, variants, selected);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-option-value]');
    if (!button) return;

    var group = button.closest('[data-product-option-group]');
    var root = button.closest('[data-product]');
    if (!group || !root) return;

    group.querySelectorAll('[data-product-option-value]').forEach(function (el) {
      var isSelected = el === button;
      el.classList.toggle('is-selected', isSelected);
      el.setAttribute('aria-pressed', isSelected);
    });

    var groups = root.querySelectorAll('[data-product-option-group]');
    var selected = Array.prototype.map.call(groups, function (g) {
      var active = g.querySelector('.is-selected');
      return active ? active.getAttribute('data-product-option-value') : null;
    });

    var variantsEl = root.querySelector('[data-product-variants-json]');
    if (!variantsEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (error) {
      return;
    }

    updateProductOptionAvailability(root, variants, selected);

    var match = variants.find(function (variant) {
      return (
        variant.options.length === selected.length &&
        variant.options.every(function (value, index) {
          return value === selected[index];
        })
      );
    });

    var idInput = root.querySelector('[data-product-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var availabilityEl = root.querySelector('[data-product-availability]');
    var atcButton = root.querySelector('[data-primary-atc]');
    var stickyPrice = document.querySelector('[data-product-sticky-atc-price]');
    var stickyButton = document.querySelector('[data-product-sticky-atc-button]');
    var addToCartLabel = root.getAttribute('data-add-to-cart-label') || '';
    var soldOutLabel = root.getAttribute('data-sold-out-label') || '';

    // Flips Add to Cart (both the inline button and the sticky bar copy)
    // into its sold-out state for whichever variant is now selected --
    // same disabled/faded treatment every other disabled .button already
    // gets (see .button:disabled in this file), just with the label text
    // swapped so it doesn't keep reading "Add to cart" while inert.
    function setAddToCartState(soldOut) {
      [atcButton, stickyButton].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = soldOut;
        btn.textContent = soldOut ? soldOutLabel : addToCartLabel;
        btn.classList.toggle('button--sold-out', soldOut);
      });
    }

    if (!match) {
      setAddToCartState(true);
      return;
    }

    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = match.price;
    if (stickyPrice) stickyPrice.textContent = match.price;
    if (availabilityEl) availabilityEl.textContent = match.availability_message;
    setAddToCartState(!match.available);

    var mainImage = root.querySelector('[data-product-gallery-main-image]');
    if (mainImage) {
      var image = match.image || {
        src: mainImage.getAttribute('data-default-src'),
        alt: mainImage.getAttribute('data-default-alt'),
        width: mainImage.getAttribute('data-default-width'),
        height: mainImage.getAttribute('data-default-height')
      };
      if (image.src) {
        mainImage.src = image.src;
        mainImage.alt = image.alt || '';
        if (image.width) mainImage.width = image.width;
        if (image.height) mainImage.height = image.height;
      }
    }
  });

  document.addEventListener('click', function (event) {
    var decrease = event.target.closest('[data-quantity-decrease]');
    var increase = event.target.closest('[data-quantity-increase]');
    if (!decrease && !increase) return;

    var stepper = (decrease || increase).closest('.product-quantity__stepper');
    var input = stepper && stepper.querySelector('[data-quantity-input]');
    if (!input) return;

    var min = parseInt(input.min, 10) || 1;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = min;

    value = increase ? value + 1 : Math.max(min, value - 1);

    input.value = value;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.product-form');
    if (!form) return;
    if (!window.fetch || !window.BustmobCart) return;

    event.preventDefault();

    var idInput = form.querySelector('[data-product-variant-id]');
    var quantityInput = form.querySelector('[name="quantity"]');
    if (!idInput) return;

    var atcButton = form.querySelector('[data-primary-atc]');
    var stickyButton = document.querySelector('[data-product-sticky-atc-button]');
    var buttons = [atcButton, stickyButton].filter(Boolean);
    var originalLabels = buttons.map(function (button) {
      return button.textContent;
    });

    buttons.forEach(function (button) {
      button.disabled = true;
    });

    window.BustmobCart.add({
      id: idInput.value,
      quantity: quantityInput ? quantityInput.value : 1
    })
      .then(function () {
        var addedLabel = form.getAttribute('data-added-label') || originalLabels[0];
        buttons.forEach(function (button) {
          button.textContent = addedLabel;
        });

        window.setTimeout(function () {
          buttons.forEach(function (button, index) {
            button.textContent = originalLabels[index];
            button.disabled = false;
          });
          window.BustmobCart.open();
        }, 1200);
      })
      .catch(function () {
        buttons.forEach(function (button) {
          button.disabled = false;
        });
      });
  });

  (function () {
    var atcButton = document.querySelector('[data-primary-atc]');
    var stickyBar = document.querySelector('[data-product-sticky-atc]');
    if (!atcButton || !stickyBar || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.hidden = !scrolledPast;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      });
    });

    observer.observe(atcButton);
  })();

  (function () {
    var recommendations = document.querySelector('[data-product-recommendations]');
    if (!recommendations) return;

    var url = recommendations.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          recommendations.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {
        // Leave the placeholder empty — recommendations are a progressive enhancement.
      });
  })();

  (function () {
    // Everything here is delegated from document rather than attached to
    // specific elements, since the recommendations block above gets its
    // innerHTML replaced entirely after the async fetch resolves -- any
    // listener bound directly to elements inside it would be discarded
    // along with them.

    var CAROUSEL_GAP = 16;
    var CAROUSEL_MIN_ITEM_WIDTH = 200;

    function getStep(track) {
      var item = track.querySelector('.product-carousel__item');
      return item ? item.getBoundingClientRect().width + CAROUSEL_GAP : track.clientWidth;
    }

    // Sizes every card so that a WHOLE number of them exactly fills the
    // track's real available width -- no partial card ever peeks over
    // the edge, and no leftover gap is left dangling on either side.
    // Recalculated on resize and whenever the recommendations markup is
    // (re)created, since track.clientWidth isn't known until then.
    function layoutCarousel(carousel) {
      var track = carousel.querySelector('[data-product-carousel-track]');
      var items = track && track.querySelectorAll('.product-carousel__item');
      if (!track || !items || !items.length) return;

      var containerWidth = track.clientWidth;
      if (!containerWidth) return;

      var maxVisible = Math.floor((containerWidth + CAROUSEL_GAP) / (CAROUSEL_MIN_ITEM_WIDTH + CAROUSEL_GAP));
      var visibleCount = Math.max(1, Math.min(maxVisible, items.length));
      var itemWidth = (containerWidth - CAROUSEL_GAP * (visibleCount - 1)) / visibleCount;

      items.forEach(function (item) {
        item.style.flex = '0 0 ' + itemWidth + 'px';
        item.style.width = itemWidth + 'px';
      });
    }

    function updateArrowState(carousel) {
      var track = carousel.querySelector('[data-product-carousel-track]');
      var prev = carousel.querySelector('[data-product-carousel-prev]');
      var next = carousel.querySelector('[data-product-carousel-next]');
      if (!track) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    document.addEventListener('click', function (event) {
      var prevButton = event.target.closest('[data-product-carousel-prev]');
      var nextButton = event.target.closest('[data-product-carousel-next]');
      if (!prevButton && !nextButton) return;

      var carousel = (prevButton || nextButton).closest('[data-product-carousel]');
      var track = carousel && carousel.querySelector('[data-product-carousel-track]');
      if (!track) return;

      var step = getStep(track);
      track.scrollBy({ left: prevButton ? -step : step, behavior: 'smooth' });
    });

    // `scroll` doesn't bubble, but it does reach ancestors during the
    // capture phase, so this still works as delegation without needing
    // to re-attach a listener every time the recommendations markup is
    // replaced.
    document.addEventListener(
      'scroll',
      function (event) {
        var track = event.target.closest && event.target.closest('[data-product-carousel-track]');
        if (!track) return;

        var carousel = track.closest('[data-product-carousel]');
        if (carousel) updateArrowState(carousel);
      },
      true
    );

    // Run once per carousel as soon as it exists: size its cards first,
    // then read the (now correct) arrow state -- before any scrolling
    // has happened -- including after the async recommendations swap
    // above.
    function initCarousels(root) {
      root.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
        layoutCarousel(carousel);
        updateArrowState(carousel);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initCarousels(document);
    });

    var recommendationsRoot = document.querySelector('[data-product-recommendations]');
    if (recommendationsRoot) {
      new MutationObserver(function () {
        initCarousels(recommendationsRoot);
      }).observe(recommendationsRoot, { childList: true });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        initCarousels(document);
      }, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recovery-guide-lead-magnet"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recovery-guide-form]').forEach(function (form) {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var webhookUrl = form.dataset.webhookUrl;
      var fields = form.querySelector('[data-recovery-guide-fields]');
      var successEl = form.querySelector('[data-recovery-guide-success]');
      var errorEl = form.querySelector('[data-recovery-guide-error]');
      var emailInput = form.querySelector('input[type="email"]');

      if (errorEl) errorEl.hidden = true;

      if (!webhookUrl) {
        console.warn(
          '[recovery-guide-lead-magnet] No webhook_url configured for this section — submission skipped until it is set.'
        );
        return;
      }

      // No explicit Content-Type header: Zapier's catch-hook endpoint
      // doesn't return the right Access-Control-Allow-Headers for a CORS
      // preflight, so setting 'Content-Type: application/json' here made
      // the browser block the request before it was ever sent (a
      // preflight is only triggered by headers/content-types outside the
      // CORS-safelist). Sending the JSON string with no headers set makes
      // fetch default to 'text/plain', which is safelisted and skips the
      // preflight entirely -- Zapier still parses the raw body as JSON
      // regardless of the declared content type.
      fetch(webhookUrl, {
        method: 'POST',
        body: JSON.stringify({ email: emailInput.value }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          if (fields) fields.hidden = true;
          if (successEl) successEl.hidden = false;
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = 'Something went wrong — please try again.';
            errorEl.hidden = false;
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.store-tab');
    if (!tab) return;

    var store = tab.closest('[data-store]');
    if (!store) return;

    var grid = store.querySelector('.store-grid');
    var tabs = store.querySelector('.store-tabs');
    if (!grid || !tabs) return;

    event.preventDefault();

    fetch(tab.href)
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.store-grid');
        var newTabs = doc.querySelector('.store-tabs');
        if (!newGrid || !newTabs) throw new Error('Missing markup');

        grid.replaceWith(newGrid);
        tabs.replaceWith(newTabs);
        history.pushState({}, '', tab.href);
      })
      .catch(function () {
        window.location.href = tab.href;
      });
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-notice"]) return;
  try {
    
    (function () {
      var STORAGE_KEY = 'bustmob:terms-notice-accepted';

      function hasAccepted() {
        try {
          return !!window.localStorage.getItem(STORAGE_KEY);
        } catch (e) {
          return false;
        }
      }

      function recordAcceptance() {
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
            accepted: true,
            timestamp: new Date().toISOString()
          }));
        } catch (e) {
          // localStorage unavailable (private mode, storage disabled, etc.) --
          // the notice will simply reappear next visit rather than error out.
        }
      }

      // Shared behavior for both variants (full modal and compact bottom
      // sheet): checkbox-gated Accept button, no Esc/backdrop dismiss,
      // focus trap, shared localStorage acceptance. `opts.animateIn`
      // triggers the compact sheet's slide-up (adds `opts.openClass` on
      // the next frame, matching Cart Drawer's own open-animation
      // technique above); the full modal doesn't pass it, so it's
      // unaffected -- same as before this variant existed.
      function initNotice(opts) {
        var notice = document.querySelector(opts.rootSelector);
        if (!notice) return;

        var panel = notice.querySelector(opts.panelSelector);
        var checkbox = notice.querySelector(opts.checkboxSelector);
        var acceptButton = notice.querySelector(opts.buttonSelector);
        var blockPage = notice.getAttribute('data-block-page') !== 'false';

        notice.hidden = false;
        if (blockPage) {
          document.body.style.overflow = 'hidden';
        }

        if (opts.animateIn) {
          window.requestAnimationFrame(function () {
            panel.classList.add(opts.openClass);
          });
        }

        checkbox.addEventListener('change', function () {
          acceptButton.disabled = !checkbox.checked;
        });

        acceptButton.addEventListener('click', function () {
          if (!checkbox.checked) return;
          recordAcceptance();
          notice.hidden = true;
          if (blockPage) {
            document.body.style.overflow = '';
          }
        });

        // Compact mode's checkbox label contains real document links.
        // Clicking one must open it, not toggle the checkbox -- browsers
        // forward a click anywhere inside a <label> to its associated
        // control via the label's own click handling, which fires
        // whenever the click event bubbles up to the label. Stopping
        // propagation here (not preventDefault, which would also block
        // the link's own navigation) keeps that bubble from ever reaching
        // the label while leaving the link free to open normally.
        var labelLinks = panel.querySelectorAll('label a[href]');
        for (var i = 0; i < labelLinks.length; i++) {
          labelLinks[i].addEventListener('click', function (event) {
            event.stopPropagation();
          });
        }

        // Focus trap: keep Tab/Shift+Tab cycling inside the panel. No
        // Escape handler and no backdrop-click handler by design -- this
        // notice can't be dismissed except by checking the box and
        // accepting.
        function getFocusable() {
          return Array.prototype.slice.call(
            panel.querySelectorAll('a[href], input:not([disabled]), button:not([disabled])')
          ).filter(function (el) {
            return el.offsetParent !== null;
          });
        }

        notice.addEventListener('keydown', function (event) {
          if (event.key !== 'Tab') return;

          var focusable = getFocusable();
          if (!focusable.length) return;

          var first = focusable[0];
          var last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        var initialFocusable = getFocusable();
        if (initialFocusable.length) initialFocusable[0].focus();
      }

      document.addEventListener('DOMContentLoaded', function () {
        if (hasAccepted()) return;

        initNotice({
          rootSelector: '[data-terms-notice]',
          panelSelector: '[data-terms-notice-panel]',
          checkboxSelector: '[data-terms-notice-checkbox]',
          buttonSelector: '[data-terms-notice-accept]',
          animateIn: false
        });

        initNotice({
          rootSelector: '[data-terms-notice-compact]',
          panelSelector: '[data-terms-notice-compact-panel]',
          checkboxSelector: '[data-terms-notice-compact-checkbox]',
          buttonSelector: '[data-terms-notice-compact-accept]',
          animateIn: true,
          openClass: 'is-open'
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
